import CardListContainer from './CardListContainer';

export default CardListContainer;
